import { render, staticRenderFns } from "./settings-exports.vue?vue&type=template&id=85ede3b6&"
import script from "./settings-exports.vue?vue&type=script&lang=js&"
export * from "./settings-exports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports